
$(document).ready(function () {
    //SIGN IN COLLAPSE SCRIPT START
    $('#sign_in_wrap').on('show.bs.collapse', function () {
        $('body').addClass('signIn-collapse-open');
    });
    $('#sign_in_wrap').on('hide.bs.collapse', function () {
        $('body').removeClass('signIn-collapse-open');
    });
    //SIGN IN COLLAPSE SCRIPT END
    //SET FOCUS IN GLOBAL SEARCH INPUT
    $('#global-search-collapse').on('show.bs.collapse', function () {
        setTimeout(function () {
            $('.global-search-wrap').find('.form-control').focus();
        }, 100);
    });
    //CITIES PROJECTS OPEN
    var urlString = location.hash.substr(1);
    $(".accordion-card-wrap .card").each(function () {
        var cardId = $(this).attr('id');
        if (urlString == cardId) {
            $(this).find('.card-header').trigger('click');
        }
    })
});
